export const curveSvg = `
<svg
  viewBox="0 0 1974 1949"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  preserveAspectRatio="xMinYMax meet"
>

  <path
    d="M956.491 41.4355C1078.09 -32.8488 1510.78 -64.7317 1821.34 463.95C1821.36 463.997 1821.37 464.055 1821.34 464.103C1821.32 464.152 1821.32 464.209 1821.35 464.256C2062.72 875.229 2056.3 1496.97 1507.69 1806.39C976.86 2105.58 410.345 1908.17 137.613 1430.44C-74.327 1059.12 -27.0908 641.73 181.257 512.124C221.887 487.33 262.752 472.767 302.197 468.143C414.383 273.545 623.575 141.929 863.719 139.347C886.204 98.5624 918.882 64.3937 956.491 41.4355Z"
    fill="url(#welcome_curve_gradient)"
  />

  <defs>
    <linearGradient
      id="welcome_curve_gradient"
      x1="1159.42"
      y1="1412.31"
      x2="837.917"
      y2="1895.81"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="var(--welcome-curve-gradient-start)"
        stop-opacity="1"
      />

      <stop
        offset="1"
        stop-color="var(--welcome-curve-gradient-end)"
        stop-opacity="1"
      />
    </linearGradient>
  </defs>
</svg>
`;
